import {SActionBtn, SLowcodeList,SSkuCard, STableActions, STags} from "shj-components";
import { Tooltip} from "antd";

import {config} from "./config.tsx";
import {useNavigate} from "react-router-dom";
import {getAuthProductManagementPage,} from "@/services/product.ts";
import {apiData2Table} from "@/utils/data.ts";
import {useRef} from "react";
import styles from "@/pages/productManage/index.module.less";
import {getBizOpTypeEnum} from "@/services/customerServices.ts";
import {getAllCompany} from "@/services/homeService.ts";
import KeepAlive from "react-activation";

const SchemeProductList = () => {
  const navigate = useNavigate()
  const listRef = useRef();
  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      getAuthProductManagementPage({
        params: {pageId: current, pageSize},
        data: {
          ...query,
          "prodType": "PRODUCT_PACKAGE",  //产品类型-套餐-写死
          "queryGoodsSku" : true, //写死
        }
      }).then(res => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }
  const onDetail = (query: any) => {
    navigate(`/config/schemeProductDetails/?packModelId=${query?.packModelId||""}&listId=${query?.id||""}&packModelName=${encodeURIComponent(query?.packModelName||"")}`)
  }

  //   下拉选项加载
  const getOptions = async () => {
    return new Promise(resolve => {
      Promise.all([
        getBizOpTypeEnum(),
        getAllCompany(),
      ]).then((res: any) => {
        const obj = {
          demandList: res[0].map((item: any) => {
            return { label: item.description, value: item.key }
          }),
          companyList: res[1],
        }
        resolve({ ...obj })
      })
    })
  }

  const extensions = {
    request: {fetchList, getOptions},
    customRender: {
      renderProduct(_, record: Record<string, any>) {
        return (
            <SSkuCard
                width={'100%'}
                url={record.mainPicUrl || ''}
                desc={record.id}
                operation={() => {
                  return <div></div>
                }}
                title={
                  <Tooltip title={record.prodName}>
                    <div className={styles.showTwoLinehidden}>{record.prodName}</div>
                  </Tooltip>
                }
            ></SSkuCard>
        )
      },
      enableRender(_, record: Record<string, any>) {
        return (
            <STags itemKey='' label={record.enabled ? '启用' : '禁用'} fontColor={record.enabled ? '#00A865' : '#EB3723'} bgColor={record.enabled ? '#D7F7EA' : '#FFEAE8'} />
        )
      },
      actionRender(_: null, record: Record<string, any>) {
        return <STableActions>
          <SActionBtn onClick={() => onDetail(record)}>详情</SActionBtn>
        </STableActions>
      }
    }
  }
  return (
      <KeepAlive name={location.pathname}>
        <SLowcodeList
              ref={listRef}
              searchMode={'group'}
              config={config}
              {...extensions}
          />
      </KeepAlive>
  );
};

export default SchemeProductList;
